function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 14a1.5 1.5 0 01-3 0M6.5 3.5c-1.5 0-3 1.125-3 3.75V11l-1.5.75v1.5h6.75",
  stroke: "#A0AFBE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 3.5c1.5 0 3 1.125 3 3.75V11l1.5.75v1.5H7.25M9.5 3.5a1.5 1.5 0 00-3 0",
  stroke: "#A0AFBE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 2.658,
  y: 1.408,
  width: 1.5,
  height: 17.482,
  rx: 0.75,
  transform: "rotate(-30 2.658 1.408)",
  fill: "#A0AFBE",
  stroke: "#fff",
  strokeWidth: 0.5
});
function SvgMuted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}
export default SvgMuted;